import React from 'react';
import Button from './Button';
import VideoModal from './VideoModal';

const HeroSection = ({handleFileChange}) => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 -mt-8 pb-12 md:-mt-12 md:pb-20 text-center">
      {/* Partner Logos */}
      <div className="flex justify-center items-center -mb-4">
        <div className="flex items-center space-x-8">
          <a 
            href="https://www.law.miami.edu/academics/mila-lab/mila-lab/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img 
              src="/mila_no_seal_white.png" 
              alt="University of Miami Law & AI Lab" 
              className="h-48 md:h-56 opacity-90 hover:opacity-100 transition-opacity duration-300 mt-4"
            />
          </a>
          <span className="text-2xl md:text-3xl text-white font-thin opacity-60">X</span>
          <a 
            href="https://bonsaiacg.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img 
              src="/bonsai_logo_white.png" 
              alt="Bonsai" 
              className="h-20 md:h-24 opacity-90 hover:opacity-100 transition-opacity duration-300 -mt-2"
            />
          </a>
        </div>
      </div>
      
      <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold mb-6 gradient-text leading-tight py-2">
        Legal Citation Generator
      </h1>
      
      <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-3xl mx-auto">
        Upload a Word document (.docx) to generate formatted legal citations.
      </p>
      
      <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-4">
        <input
          type="file"
          id="hero-file-upload"
          onChange={handleFileChange}
          accept=".docx"
          className='sr-only'
        />
        <Button 
          onClick={()=> document.getElementById('hero-file-upload').click()}
          href="#upload-section" 
          variant="primary"
          className="button-glow"
        >
          Upload Document
        </Button>
        
        <VideoModal 
          videoId="your-video-id" 
          title="Watch Demo"
        />
      </div>
    </div>
  );
};

export default HeroSection;
